import * as common from '../apiCommon';
import { CUSTOM_TAB } from '../../constants/constant_doc_types';
import { toBoolean } from '../apiUtils';

export function fetchCustomTabDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'custom_tab/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export const fetchCustomTabById = (app, params) => {
  const { id } = params;
  const docType = CUSTOM_TAB;

  return common.getDoc(app, { id, docType });
}

export const saveCustomTab = (app, dataToSave) => {
  const { user = {}, data } = dataToSave;

  const customTabData = {
    active: data.active,
    allow_skip: data.allow_skip,
    doc_type: CUSTOM_TAB,
    name: data.name,
    description: data.description,
    type: data.type,
    show_on_pos: toBoolean(data.show_on_pos),
  };

  return common.saveDoc(app, {
    source: data,
    doc: customTabData,
    user,
  });
}

export const deleteCustomTab = (app, data) => {
  return common.deleteDoc(app, {
    id: data.id,
    docType: CUSTOM_TAB,
  });
}
